import { METHODOLOGY_EXPLAINER_PAGE_BU, METHODOLOGY_EXPLAINER_PAGE_VNU } from '@/config/constants';

import { useProject } from './useProject';

export const useMethodologyPageLink = () => {
  const project = useProject().data;

  return project.natureUnitVariant === 'vnu' ? METHODOLOGY_EXPLAINER_PAGE_VNU : METHODOLOGY_EXPLAINER_PAGE_BU;
};
